import { render, staticRenderFns } from "./DailySummary.vue?vue&type=template&id=2b6d2acd&scoped=true&"
import script from "./DailySummary.vue?vue&type=script&lang=js&"
export * from "./DailySummary.vue?vue&type=script&lang=js&"
import style0 from "./DailySummary.vue?vue&type=style&index=0&id=2b6d2acd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6d2acd",
  null
  
)

export default component.exports